export default function PageHero({ overline, title, subtitle, image, imagePosition, children }) {
  return (
    <section className="relative pt-28 lg:pt-36 pb-20 lg:pb-28 overflow-hidden" data-testid="page-hero">
      {image && (
        <>
          <img
            src={image}
            alt=""
            className="absolute inset-0 w-full h-full object-cover opacity-70"
            style={imagePosition ? { objectPosition: imagePosition } : undefined}
          />
          <div className="absolute inset-0 hero-vignette" />
        </>
      )}
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        {overline && <div className="overline rise">{overline}</div>}
        <h1 className="font-display text-4xl sm:text-5xl lg:text-7xl leading-[1.02] tracking-tight mt-3 text-white rise-2 max-w-4xl">
          {title}
        </h1>
        <div className="divider-gold rise-3" />
        {subtitle && (
          <p className="max-w-2xl text-slate-300 text-base lg:text-lg leading-relaxed rise-3">
            {subtitle}
          </p>
        )}
        {children && <div className="mt-8 rise-4">{children}</div>}
      </div>
    </section>
  );
}
